export const today = () => {
  const pad = (n) => Math.abs(n).toString().padStart(2, '0')
  const d = new Date()
  const year = pad(d.getFullYear(), 4)
  const month = pad(d.getMonth() + 1, 2)
  const day = pad(d.getDate(), 2)
  return `${year}-${month}-${day}`
}

export const trim = (str) => str?.replace(/\n+/g, ' ')
